import { useEffect, useState } from 'react'
import { IPopMessageProvider, TPopMessageData } from './types'
import styles from './styles.module.scss'
import PopMessageItem from './PopMessageItem'

// Wrap provides state and creates event listener
export const PopMessageProvider = ({ children }: IPopMessageProvider) => {
  const [messages, setMessage] = useState<TPopMessageData[]>([])

  const handleCustomEvent: EventListener = (event) => {
    if (event instanceof CustomEvent) {
      const newPopMessage: TPopMessageData = {
        id: Date.now(),
        ...event.detail,
      }
      newPopMessage.title && setMessage((prevState) => [...prevState, { ...newPopMessage }])
    }
  }

  const handleClose = (id: number) => {
    setMessage((prevState) => prevState.filter((message) => message.id !== id))
  }

  useEffect(() => {
    // Subscribe event
    document.addEventListener('pop-message', handleCustomEvent)
    return () => {
      // Unsubscribe event
      document.removeEventListener('pop-message', handleCustomEvent)
      setMessage([])
    }
  }, [])

  return (
    <>
      <aside aria-live="polite" className={styles.aside}>
        {messages.map((itemProps) => (
          <PopMessageItem key={itemProps.id} onClose={handleClose} {...itemProps} />
        ))}
      </aside>
      {children}
    </>
  )
}

export default PopMessageProvider
